var map = {
	"./1.gif": "11eb",
	"./2.gif": "ffe1",
	"./3.gif": "5da1",
	"./4.gif": "5f34",
	"./5.gif": "4482",
	"./6.gif": "b63f",
	"./7.gif": "7dc1",
	"./8.gif": "06ef",
	"./9.gif": "1c89",
	"./cen_03.gif": "6f4e",
	"./clo_06.gif": "f895",
	"./g_03.gif": "9725"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc6d";